import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	whenTitle: {
		id: 'servicedesk.automation.common.common.when-title',
		defaultMessage: 'When this happens...',
		description: '',
	},
	firstIfTitle: {
		id: 'servicedesk.automation.common.common.first-if-title',
		defaultMessage: 'If these match...',
		description: '',
	},
	middleIfTitle: {
		id: 'servicedesk.automation.common.common.middle-if-title',
		defaultMessage: 'Otherwise, if these match...',
		description: '',
	},
	normalThenTitle: {
		id: 'servicedesk.automation.common.common.normal-then-title',
		defaultMessage: 'Then do this...',
		description: '',
	},
	lastAndOnlyThenTitle: {
		id: 'servicedesk.automation.common.common.last-and-only-then-title',
		defaultMessage: 'Otherwise, do this...',
		description: '',
	},
	unsavedChanges: {
		id: 'servicedesk.automation.common.common.unsaved-changes',
		defaultMessage: 'You have unsaved changes. Save or discard your changes to continue.',
		description: '',
	},
	searching: {
		id: 'servicedesk.automation.common.common.searching',
		defaultMessage: 'Searching...',
		description: '',
	},
});
